import React from 'react'
import AnalyticsSidebar from './components/sidebar'

const Analytics = ({ client }) => {

  return (
    <div>
      <AnalyticsSidebar client={client} />
    </div>
  );
};

export default Analytics;
